import type { ICountry } from './i-country';

/**
 * Full ISO 3166-1 alpha-2 country and territory list including native names and default currency codes.
 * Drives the CountryCode enum, lookups, and VAT ID validation.
 */
export const COUNTRIES = [
  { code: 'AF', name: 'Afghanistan', nativeName: 'افغانستان', currencyCode: 'AFN' },
  { code: 'AX', name: 'Åland Islands', nativeName: 'Åland', currencyCode: 'EUR' },
  { code: 'AL', name: 'Albania', nativeName: 'Shqipëria', currencyCode: 'ALL' },
  { code: 'DZ', name: 'Algeria', nativeName: 'الجزائر', currencyCode: 'DZD' },
  { code: 'AS', name: 'American Samoa', nativeName: 'American Samoa', currencyCode: 'USD' },
  { code: 'AD', name: 'Andorra', nativeName: 'Andorra', currencyCode: 'EUR' },
  { code: 'AO', name: 'Angola', nativeName: 'Angola', currencyCode: 'AOA' },
  { code: 'AI', name: 'Anguilla', nativeName: 'Anguilla', currencyCode: 'XCD' },
  { code: 'AQ', name: 'Antarctica', nativeName: 'Antarctica', currencyCode: undefined },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
    nativeName: 'Antigua and Barbuda',
    currencyCode: 'XCD'
  },
  { code: 'AR', name: 'Argentina', nativeName: 'Argentina', currencyCode: 'ARS' },
  { code: 'AM', name: 'Armenia', nativeName: 'Հայաստան', currencyCode: 'AMD' },
  { code: 'AW', name: 'Aruba', nativeName: 'Aruba', currencyCode: 'AWG' },
  { code: 'AU', name: 'Australia', nativeName: 'Australia', currencyCode: 'AUD' },
  { code: 'AT', name: 'Austria', nativeName: 'Österreich', currencyCode: 'EUR' },
  { code: 'AZ', name: 'Azerbaijan', nativeName: 'Azərbaycan', currencyCode: 'AZN' },
  { code: 'BS', name: 'Bahamas', nativeName: 'Bahamas', currencyCode: 'BSD' },
  { code: 'BH', name: 'Bahrain', nativeName: 'البحرين', currencyCode: 'BHD' },
  { code: 'BD', name: 'Bangladesh', nativeName: 'বাংলাদেশ', currencyCode: 'BDT' },
  { code: 'BB', name: 'Barbados', nativeName: 'Barbados', currencyCode: 'BBD' },
  { code: 'BY', name: 'Belarus', nativeName: 'Беларусь', currencyCode: 'BYN' },
  { code: 'BE', name: 'Belgium', nativeName: 'België', currencyCode: 'EUR' },
  { code: 'BZ', name: 'Belize', nativeName: 'Belize', currencyCode: 'BZD' },
  { code: 'BJ', name: 'Benin', nativeName: 'Bénin', currencyCode: 'XOF' },
  { code: 'BM', name: 'Bermuda', nativeName: 'Bermuda', currencyCode: 'BMD' },
  { code: 'BT', name: 'Bhutan', nativeName: 'འབྲུག', currencyCode: 'BTN' },
  { code: 'BO', name: 'Bolivia', nativeName: 'Bolivia', currencyCode: 'BOB' },
  {
    code: 'BQ',
    name: 'Bonaire, Sint Eustatius and Saba',
    nativeName: 'Bonaire',
    currencyCode: 'USD'
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    nativeName: 'Bosna i Hercegovina',
    currencyCode: 'BAM'
  },
  { code: 'BW', name: 'Botswana', nativeName: 'Botswana', currencyCode: 'BWP' },
  { code: 'BV', name: 'Bouvet Island', nativeName: 'Bouvetøya', currencyCode: 'NOK' },
  { code: 'BR', name: 'Brazil', nativeName: 'Brasil', currencyCode: 'BRL' },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    nativeName: 'British Indian Ocean Territory',
    currencyCode: 'USD'
  },
  { code: 'BN', name: 'Brunei', nativeName: 'Brunei', currencyCode: 'BND' },
  { code: 'BG', name: 'Bulgaria', nativeName: 'България', currencyCode: 'BGN' },
  { code: 'BF', name: 'Burkina Faso', nativeName: 'Burkina Faso', currencyCode: 'XOF' },
  { code: 'BI', name: 'Burundi', nativeName: 'Burundi', currencyCode: 'BIF' },
  { code: 'CV', name: 'Cabo Verde', nativeName: 'Cabo Verde', currencyCode: 'CVE' },
  { code: 'KH', name: 'Cambodia', nativeName: 'កម្ពុជា', currencyCode: 'KHR' },
  { code: 'CM', name: 'Cameroon', nativeName: 'Cameroun', currencyCode: 'XAF' },
  { code: 'CA', name: 'Canada', nativeName: 'Canada', currencyCode: 'CAD' },
  { code: 'KY', name: 'Cayman Islands', nativeName: 'Cayman Islands', currencyCode: 'KYD' },
  {
    code: 'CF',
    name: 'Central African Republic',
    nativeName: 'République centrafricaine',
    currencyCode: 'XAF'
  },
  { code: 'TD', name: 'Chad', nativeName: 'Tchad', currencyCode: 'XAF' },
  { code: 'CL', name: 'Chile', nativeName: 'Chile', currencyCode: 'CLP' },
  { code: 'CN', name: 'China', nativeName: '中国', currencyCode: 'CNY' },
  { code: 'CX', name: 'Christmas Island', nativeName: 'Christmas Island', currencyCode: 'AUD' },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    nativeName: 'Cocos (Keeling) Islands',
    currencyCode: 'AUD'
  },
  { code: 'CO', name: 'Colombia', nativeName: 'Colombia', currencyCode: 'COP' },
  { code: 'KM', name: 'Comoros', nativeName: 'جزر القمر', currencyCode: 'KMF' },
  { code: 'CG', name: 'Congo', nativeName: 'Congo', currencyCode: 'XAF' },
  { code: 'CD', name: 'Congo (DRC)', nativeName: 'RD Congo', currencyCode: 'CDF' },
  { code: 'CK', name: 'Cook Islands', nativeName: 'Cook Islands', currencyCode: 'NZD' },
  { code: 'CR', name: 'Costa Rica', nativeName: 'Costa Rica', currencyCode: 'CRC' },
  { code: 'CI', name: "Côte d'Ivoire", nativeName: "Côte d'Ivoire", currencyCode: 'XOF' },
  { code: 'HR', name: 'Croatia', nativeName: 'Hrvatska', currencyCode: 'EUR' },
  { code: 'CU', name: 'Cuba', nativeName: 'Cuba', currencyCode: 'CUP' },
  { code: 'CW', name: 'Curaçao', nativeName: 'Curaçao', currencyCode: 'ANG' },
  { code: 'CY', name: 'Cyprus', nativeName: 'Κύπρος', currencyCode: 'EUR' },
  { code: 'CZ', name: 'Czechia', nativeName: 'Česko', currencyCode: 'CZK' },
  { code: 'DK', name: 'Denmark', nativeName: 'Danmark', currencyCode: 'DKK' },
  { code: 'DJ', name: 'Djibouti', nativeName: 'جيبوتي', currencyCode: 'DJF' },
  { code: 'DM', name: 'Dominica', nativeName: 'Dominica', currencyCode: 'XCD' },
  {
    code: 'DO',
    name: 'Dominican Republic',
    nativeName: 'República Dominicana',
    currencyCode: 'DOP'
  },
  { code: 'EC', name: 'Ecuador', nativeName: 'Ecuador', currencyCode: 'USD' },
  { code: 'EG', name: 'Egypt', nativeName: 'مصر', currencyCode: 'EGP' },
  { code: 'SV', name: 'El Salvador', nativeName: 'El Salvador', currencyCode: 'USD' },
  { code: 'GQ', name: 'Equatorial Guinea', nativeName: 'Guinea Ecuatorial', currencyCode: 'XAF' },
  { code: 'ER', name: 'Eritrea', nativeName: 'ኤርትራ', currencyCode: 'ERN' },
  { code: 'EE', name: 'Estonia', nativeName: 'Eesti', currencyCode: 'EUR' },
  { code: 'SZ', name: 'Eswatini', nativeName: 'Eswatini', currencyCode: 'SZL' },
  { code: 'ET', name: 'Ethiopia', nativeName: 'ኢትዮጵያ', currencyCode: 'ETB' },
  { code: 'FK', name: 'Falkland Islands', nativeName: 'Falkland Islands', currencyCode: 'FKP' },
  { code: 'FO', name: 'Faroe Islands', nativeName: 'Føroyar', currencyCode: 'DKK' },
  { code: 'FJ', name: 'Fiji', nativeName: 'Fiji', currencyCode: 'FJD' },
  { code: 'FI', name: 'Finland', nativeName: 'Suomi', currencyCode: 'EUR' },
  { code: 'FR', name: 'France', nativeName: 'France', currencyCode: 'EUR' },
  { code: 'GF', name: 'French Guiana', nativeName: 'Guyane', currencyCode: 'EUR' },
  { code: 'PF', name: 'French Polynesia', nativeName: 'Polynésie française', currencyCode: 'XPF' },
  {
    code: 'TF',
    name: 'French Southern Territories',
    nativeName: 'Terres australes françaises',
    currencyCode: 'EUR'
  },
  { code: 'GA', name: 'Gabon', nativeName: 'Gabon', currencyCode: 'XAF' },
  { code: 'GM', name: 'Gambia', nativeName: 'Gambia', currencyCode: 'GMD' },
  { code: 'GE', name: 'Georgia', nativeName: 'საქართველო', currencyCode: 'GEL' },
  { code: 'DE', name: 'Germany', nativeName: 'Deutschland', currencyCode: 'EUR' },
  { code: 'GH', name: 'Ghana', nativeName: 'Ghana', currencyCode: 'GHS' },
  { code: 'GI', name: 'Gibraltar', nativeName: 'Gibraltar', currencyCode: 'GIP' },
  { code: 'GR', name: 'Greece', nativeName: 'Ελλάδα', currencyCode: 'EUR' },
  { code: 'GL', name: 'Greenland', nativeName: 'Kalaallit Nunaat', currencyCode: 'DKK' },
  { code: 'GD', name: 'Grenada', nativeName: 'Grenada', currencyCode: 'XCD' },
  { code: 'GP', name: 'Guadeloupe', nativeName: 'Guadeloupe', currencyCode: 'EUR' },
  { code: 'GU', name: 'Guam', nativeName: 'Guam', currencyCode: 'USD' },
  { code: 'GT', name: 'Guatemala', nativeName: 'Guatemala', currencyCode: 'GTQ' },
  { code: 'GG', name: 'Guernsey', nativeName: 'Guernsey', currencyCode: 'GBP' },
  { code: 'GN', name: 'Guinea', nativeName: 'Guinée', currencyCode: 'GNF' },
  { code: 'GW', name: 'Guinea-Bissau', nativeName: 'Guiné-Bissau', currencyCode: 'XOF' },
  { code: 'GY', name: 'Guyana', nativeName: 'Guyana', currencyCode: 'GYD' },
  { code: 'HT', name: 'Haiti', nativeName: 'Haïti', currencyCode: 'HTG' },
  {
    code: 'HM',
    name: 'Heard Island and McDonald Islands',
    nativeName: 'Heard Island and McDonald Islands',
    currencyCode: 'AUD'
  },
  { code: 'VA', name: 'Vatican City', nativeName: 'Vaticano', currencyCode: 'EUR' },
  { code: 'HN', name: 'Honduras', nativeName: 'Honduras', currencyCode: 'HNL' },
  { code: 'HK', name: 'Hong Kong', nativeName: '香港', currencyCode: 'HKD' },
  { code: 'HU', name: 'Hungary', nativeName: 'Magyarország', currencyCode: 'HUF' },
  { code: 'IS', name: 'Iceland', nativeName: 'Ísland', currencyCode: 'ISK' },
  { code: 'IN', name: 'India', nativeName: 'भारत', currencyCode: 'INR' },
  { code: 'ID', name: 'Indonesia', nativeName: 'Indonesia', currencyCode: 'IDR' },
  { code: 'IR', name: 'Iran', nativeName: 'ایران', currencyCode: 'IRR' },
  { code: 'IQ', name: 'Iraq', nativeName: 'العراق', currencyCode: 'IQD' },
  { code: 'IE', name: 'Ireland', nativeName: 'Éire', currencyCode: 'EUR' },
  { code: 'IM', name: 'Isle of Man', nativeName: 'Isle of Man', currencyCode: 'GBP' },
  { code: 'IL', name: 'Israel', nativeName: 'ישראל', currencyCode: 'ILS' },
  { code: 'IT', name: 'Italy', nativeName: 'Italia', currencyCode: 'EUR' },
  { code: 'JM', name: 'Jamaica', nativeName: 'Jamaica', currencyCode: 'JMD' },
  { code: 'JP', name: 'Japan', nativeName: '日本', currencyCode: 'JPY' },
  { code: 'JE', name: 'Jersey', nativeName: 'Jersey', currencyCode: 'GBP' },
  { code: 'JO', name: 'Jordan', nativeName: 'الأردن', currencyCode: 'JOD' },
  { code: 'KZ', name: 'Kazakhstan', nativeName: 'Қазақстан', currencyCode: 'KZT' },
  { code: 'KE', name: 'Kenya', nativeName: 'Kenya', currencyCode: 'KES' },
  { code: 'KI', name: 'Kiribati', nativeName: 'Kiribati', currencyCode: 'AUD' },
  { code: 'KP', name: 'North Korea', nativeName: '조선', currencyCode: 'KPW' },
  { code: 'KR', name: 'South Korea', nativeName: '대한민국', currencyCode: 'KRW' },
  { code: 'KW', name: 'Kuwait', nativeName: 'الكويت', currencyCode: 'KWD' },
  { code: 'KG', name: 'Kyrgyzstan', nativeName: 'Кыргызстан', currencyCode: 'KGS' },
  { code: 'LA', name: 'Laos', nativeName: 'ລາວ', currencyCode: 'LAK' },
  { code: 'LV', name: 'Latvia', nativeName: 'Latvija', currencyCode: 'EUR' },
  { code: 'LB', name: 'Lebanon', nativeName: 'لبنان', currencyCode: 'LBP' },
  { code: 'LS', name: 'Lesotho', nativeName: 'Lesotho', currencyCode: 'LSL' },
  { code: 'LR', name: 'Liberia', nativeName: 'Liberia', currencyCode: 'LRD' },
  { code: 'LY', name: 'Libya', nativeName: 'ليبيا', currencyCode: 'LYD' },
  { code: 'LI', name: 'Liechtenstein', nativeName: 'Liechtenstein', currencyCode: 'CHF' },
  { code: 'LT', name: 'Lithuania', nativeName: 'Lietuva', currencyCode: 'EUR' },
  { code: 'LU', name: 'Luxembourg', nativeName: 'Luxembourg', currencyCode: 'EUR' },
  { code: 'MO', name: 'Macao', nativeName: '澳門', currencyCode: 'MOP' },
  { code: 'MG', name: 'Madagascar', nativeName: 'Madagasikara', currencyCode: 'MGA' },
  { code: 'MW', name: 'Malawi', nativeName: 'Malawi', currencyCode: 'MWK' },
  { code: 'MY', name: 'Malaysia', nativeName: 'Malaysia', currencyCode: 'MYR' },
  { code: 'MV', name: 'Maldives', nativeName: 'ދިވެހިރާއްޖެ', currencyCode: 'MVR' },
  { code: 'ML', name: 'Mali', nativeName: 'Mali', currencyCode: 'XOF' },
  { code: 'MT', name: 'Malta', nativeName: 'Malta', currencyCode: 'EUR' },
  { code: 'MH', name: 'Marshall Islands', nativeName: 'Marshall Islands', currencyCode: 'USD' },
  { code: 'MQ', name: 'Martinique', nativeName: 'Martinique', currencyCode: 'EUR' },
  { code: 'MR', name: 'Mauritania', nativeName: 'موريتانيا', currencyCode: 'MRU' },
  { code: 'MU', name: 'Mauritius', nativeName: 'Maurice', currencyCode: 'MUR' },
  { code: 'YT', name: 'Mayotte', nativeName: 'Mayotte', currencyCode: 'EUR' },
  { code: 'MX', name: 'Mexico', nativeName: 'México', currencyCode: 'MXN' },
  { code: 'FM', name: 'Micronesia', nativeName: 'Micronesia', currencyCode: 'USD' },
  { code: 'MD', name: 'Moldova', nativeName: 'Moldova', currencyCode: 'MDL' },
  { code: 'MC', name: 'Monaco', nativeName: 'Monaco', currencyCode: 'EUR' },
  { code: 'MN', name: 'Mongolia', nativeName: 'Монгол', currencyCode: 'MNT' },
  { code: 'ME', name: 'Montenegro', nativeName: 'Crna Gora', currencyCode: 'EUR' },
  { code: 'MS', name: 'Montserrat', nativeName: 'Montserrat', currencyCode: 'XCD' },
  { code: 'MA', name: 'Morocco', nativeName: 'المغرب', currencyCode: 'MAD' },
  { code: 'MZ', name: 'Mozambique', nativeName: 'Moçambique', currencyCode: 'MZN' },
  { code: 'MM', name: 'Myanmar', nativeName: 'မြန်မာ', currencyCode: 'MMK' },
  { code: 'NA', name: 'Namibia', nativeName: 'Namibia', currencyCode: 'NAD' },
  { code: 'NR', name: 'Nauru', nativeName: 'Nauru', currencyCode: 'AUD' },
  { code: 'NP', name: 'Nepal', nativeName: 'नेपाल', currencyCode: 'NPR' },
  { code: 'NL', name: 'Netherlands', nativeName: 'Nederland', currencyCode: 'EUR' },
  { code: 'NC', name: 'New Caledonia', nativeName: 'Nouvelle-Calédonie', currencyCode: 'XPF' },
  { code: 'NZ', name: 'New Zealand', nativeName: 'New Zealand', currencyCode: 'NZD' },
  { code: 'NI', name: 'Nicaragua', nativeName: 'Nicaragua', currencyCode: 'NIO' },
  { code: 'NE', name: 'Niger', nativeName: 'Niger', currencyCode: 'XOF' },
  { code: 'NG', name: 'Nigeria', nativeName: 'Nigeria', currencyCode: 'NGN' },
  { code: 'NU', name: 'Niue', nativeName: 'Niue', currencyCode: 'NZD' },
  { code: 'NF', name: 'Norfolk Island', nativeName: 'Norfolk Island', currencyCode: 'AUD' },
  { code: 'MK', name: 'North Macedonia', nativeName: 'Северна Македонија', currencyCode: 'MKD' },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
    nativeName: 'Northern Mariana Islands',
    currencyCode: 'USD'
  },
  { code: 'NO', name: 'Norway', nativeName: 'Norge', currencyCode: 'NOK' },
  { code: 'OM', name: 'Oman', nativeName: 'عمان', currencyCode: 'OMR' },
  { code: 'PK', name: 'Pakistan', nativeName: 'پاکستان', currencyCode: 'PKR' },
  { code: 'PW', name: 'Palau', nativeName: 'Palau', currencyCode: 'USD' },
  { code: 'PS', name: 'Palestine', nativeName: 'فلسطين', currencyCode: 'ILS' },
  { code: 'PA', name: 'Panama', nativeName: 'Panamá', currencyCode: 'PAB' },
  { code: 'PG', name: 'Papua New Guinea', nativeName: 'Papua New Guinea', currencyCode: 'PGK' },
  { code: 'PY', name: 'Paraguay', nativeName: 'Paraguay', currencyCode: 'PYG' },
  { code: 'PE', name: 'Peru', nativeName: 'Perú', currencyCode: 'PEN' },
  { code: 'PH', name: 'Philippines', nativeName: 'Pilipinas', currencyCode: 'PHP' },
  { code: 'PN', name: 'Pitcairn', nativeName: 'Pitcairn', currencyCode: 'NZD' },
  { code: 'PL', name: 'Poland', nativeName: 'Polska', currencyCode: 'PLN' },
  { code: 'PT', name: 'Portugal', nativeName: 'Portugal', currencyCode: 'EUR' },
  { code: 'PR', name: 'Puerto Rico', nativeName: 'Puerto Rico', currencyCode: 'USD' },
  { code: 'QA', name: 'Qatar', nativeName: 'قطر', currencyCode: 'QAR' },
  { code: 'RE', name: 'Réunion', nativeName: 'La Réunion', currencyCode: 'EUR' },
  { code: 'RO', name: 'Romania', nativeName: 'România', currencyCode: 'RON' },
  { code: 'RU', name: 'Russia', nativeName: 'Россия', currencyCode: 'RUB' },
  { code: 'RW', name: 'Rwanda', nativeName: 'Rwanda', currencyCode: 'RWF' },
  { code: 'BL', name: 'Saint Barthélemy', nativeName: 'Saint-Barthélemy', currencyCode: 'EUR' },
  {
    code: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    nativeName: 'Saint Helena',
    currencyCode: 'SHP'
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
    nativeName: 'Saint Kitts and Nevis',
    currencyCode: 'XCD'
  },
  { code: 'LC', name: 'Saint Lucia', nativeName: 'Saint Lucia', currencyCode: 'XCD' },
  {
    code: 'MF',
    name: 'Saint Martin (French part)',
    nativeName: 'Saint-Martin',
    currencyCode: 'EUR'
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
    nativeName: 'Saint-Pierre-et-Miquelon',
    currencyCode: 'EUR'
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
    nativeName: 'Saint Vincent and the Grenadines',
    currencyCode: 'XCD'
  },
  { code: 'WS', name: 'Samoa', nativeName: 'Samoa', currencyCode: 'WST' },
  { code: 'SM', name: 'San Marino', nativeName: 'San Marino', currencyCode: 'EUR' },
  {
    code: 'ST',
    name: 'São Tomé and Príncipe',
    nativeName: 'São Tomé e Príncipe',
    currencyCode: 'STN'
  },
  { code: 'SA', name: 'Saudi Arabia', nativeName: 'السعودية', currencyCode: 'SAR' },
  { code: 'SN', name: 'Senegal', nativeName: 'Sénégal', currencyCode: 'XOF' },
  { code: 'RS', name: 'Serbia', nativeName: 'Србија', currencyCode: 'RSD' },
  { code: 'SC', name: 'Seychelles', nativeName: 'Seychelles', currencyCode: 'SCR' },
  { code: 'SL', name: 'Sierra Leone', nativeName: 'Sierra Leone', currencyCode: 'SLE' },
  { code: 'SG', name: 'Singapore', nativeName: 'Singapore', currencyCode: 'SGD' },
  {
    code: 'SX',
    name: 'Sint Maarten (Dutch part)',
    nativeName: 'Sint Maarten',
    currencyCode: 'ANG'
  },
  { code: 'SK', name: 'Slovakia', nativeName: 'Slovensko', currencyCode: 'EUR' },
  { code: 'SI', name: 'Slovenia', nativeName: 'Slovenija', currencyCode: 'EUR' },
  { code: 'SB', name: 'Solomon Islands', nativeName: 'Solomon Islands', currencyCode: 'SBD' },
  { code: 'SO', name: 'Somalia', nativeName: 'Soomaaliya', currencyCode: 'SOS' },
  { code: 'ZA', name: 'South Africa', nativeName: 'South Africa', currencyCode: 'ZAR' },
  {
    code: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
    nativeName: 'South Georgia',
    currencyCode: undefined
  },
  { code: 'SS', name: 'South Sudan', nativeName: 'South Sudan', currencyCode: 'SSP' },
  { code: 'ES', name: 'Spain', nativeName: 'España', currencyCode: 'EUR' },
  { code: 'LK', name: 'Sri Lanka', nativeName: 'ශ්‍රී ලංකාව', currencyCode: 'LKR' },
  { code: 'SD', name: 'Sudan', nativeName: 'السودان', currencyCode: 'SDG' },
  { code: 'SR', name: 'Suriname', nativeName: 'Suriname', currencyCode: 'SRD' },
  {
    code: 'SJ',
    name: 'Svalbard and Jan Mayen',
    nativeName: 'Svalbard og Jan Mayen',
    currencyCode: 'NOK'
  },
  { code: 'SE', name: 'Sweden', nativeName: 'Sverige', currencyCode: 'SEK' },
  { code: 'CH', name: 'Switzerland', nativeName: 'Schweiz', currencyCode: 'CHF' },
  { code: 'SY', name: 'Syria', nativeName: 'سوريا', currencyCode: 'SYP' },
  { code: 'TW', name: 'Taiwan', nativeName: '臺灣', currencyCode: 'TWD' },
  { code: 'TJ', name: 'Tajikistan', nativeName: 'Тоҷикистон', currencyCode: 'TJS' },
  { code: 'TZ', name: 'Tanzania', nativeName: 'Tanzania', currencyCode: 'TZS' },
  { code: 'TH', name: 'Thailand', nativeName: 'ประเทศไทย', currencyCode: 'THB' },
  { code: 'TL', name: 'Timor-Leste', nativeName: 'Timor-Leste', currencyCode: 'USD' },
  { code: 'TG', name: 'Togo', nativeName: 'Togo', currencyCode: 'XOF' },
  { code: 'TK', name: 'Tokelau', nativeName: 'Tokelau', currencyCode: 'NZD' },
  { code: 'TO', name: 'Tonga', nativeName: 'Tonga', currencyCode: 'TOP' },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
    nativeName: 'Trinidad and Tobago',
    currencyCode: 'TTD'
  },
  { code: 'TN', name: 'Tunisia', nativeName: 'تونس', currencyCode: 'TND' },
  { code: 'TR', name: 'Turkey', nativeName: 'Türkiye', currencyCode: 'TRY' },
  { code: 'TM', name: 'Turkmenistan', nativeName: 'Türkmenistan', currencyCode: 'TMT' },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
    nativeName: 'Turks and Caicos Islands',
    currencyCode: 'USD'
  },
  { code: 'TV', name: 'Tuvalu', nativeName: 'Tuvalu', currencyCode: 'AUD' },
  { code: 'UG', name: 'Uganda', nativeName: 'Uganda', currencyCode: 'UGX' },
  { code: 'UA', name: 'Ukraine', nativeName: 'Україна', currencyCode: 'UAH' },
  { code: 'AE', name: 'United Arab Emirates', nativeName: 'الإمارات', currencyCode: 'AED' },
  { code: 'GB', name: 'United Kingdom', nativeName: 'United Kingdom', currencyCode: 'GBP' },
  {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
    nativeName: 'United States Minor Outlying Islands',
    currencyCode: 'USD'
  },
  { code: 'US', name: 'United States', nativeName: 'United States', currencyCode: 'USD' },
  { code: 'UY', name: 'Uruguay', nativeName: 'Uruguay', currencyCode: 'UYU' },
  { code: 'UZ', name: 'Uzbekistan', nativeName: 'O\u02BBzbekiston', currencyCode: 'UZS' },
  { code: 'VU', name: 'Vanuatu', nativeName: 'Vanuatu', currencyCode: 'VUV' },
  { code: 'VE', name: 'Venezuela', nativeName: 'Venezuela', currencyCode: 'VES' },
  { code: 'VN', name: 'Vietnam', nativeName: 'Việt Nam', currencyCode: 'VND' },
  {
    code: 'VG',
    name: 'Virgin Islands (British)',
    nativeName: 'British Virgin Islands',
    currencyCode: 'USD'
  },
  {
    code: 'VI',
    name: 'Virgin Islands (U.S.)',
    nativeName: 'United States Virgin Islands',
    currencyCode: 'USD'
  },
  { code: 'WF', name: 'Wallis and Futuna', nativeName: 'Wallis-et-Futuna', currencyCode: 'XPF' },
  { code: 'EH', name: 'Western Sahara', nativeName: 'الصحراء الغربية', currencyCode: 'MAD' },
  { code: 'YE', name: 'Yemen', nativeName: 'اليمن', currencyCode: 'YER' },
  { code: 'ZM', name: 'Zambia', nativeName: 'Zambia', currencyCode: 'ZMW' },
  { code: 'ZW', name: 'Zimbabwe', nativeName: 'Zimbabwe', currencyCode: 'ZWL' }
] as const satisfies readonly ICountry[];
